<template>

    <div class="ecpec" :id="randomId">

        <froala :tag="'textarea'" :config="froalaConfig" v-model="element.content"></froala>

    </div>

</template>


<script>
// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)


export default {

    name: 'catalogPageElementContent',

    props: {
        element: {
            type: Object,
            required: false,
            default: function() { return {} }
        }
    },

    components: {
        VueFroala
    },


    computed: {

        randomId() {
            return '_' + Math.random().toString(36).substr(2, 9);
        }

    },

	data() {

        var self = this;
		return {

            // https://www.froala.com/wysiwyg-editor/examples/custom-dropdown
            // https://www.froala.com/wysiwyg-editor/examples/custom-buttons
            // https://www.froala.com/wysiwyg-editor/examples/custom-popup
            // https://stackoverflow.com/questions/42998984/froala-custom-template-button
            froalaConfig: {
                // key: '9A-8nptighakmfG-7hfdkF5oH-9==',
                key: '',
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'paragraphStyle', '|', 'subscript', 'superscript', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertTable', '|', 'insertImage', 'insertLink', '|', 'undo', 'redo'],
                paragraphMultipleStyles: false,
                paragraphStyles: {
                    'fr-text-headline': 'Überschrift',
                    'fr-text-teaser': 'Text größer',
                    'fr-text-annotation': 'Anmerkung'
                },
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
                imageManagerLoadURL: '',
                imageUploadURL: '',
                imageUploadParams: { froala: 1 },
				imageInsertButtons: ['imageUpload'],
				imageDefaultWidth: 150,
				imageDefaultAlign: 'left',
                imageEditButtons: ['imageReplace', 'imageAlign', 'imageDisplay',  'imageCaption', 'imageRemove'],
                charCounterCount: false,
                pastePlain: true,
                initOnClick: false,
                requestHeaders: {
					"Authorization": 'Basic ' + localStorage.getItem('token')
			  	},
                quickInsertButtons: ['image', 'table', 'ul', 'ol'],
                language: 'de',
	            tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
                tableMultipleStyles: false,
                tableResizer: true,
                // tableResizerOffset: 10,
                // tableResizingLimit: 10,
                quickInsertTags: [],        // disable quickInsertBar

                events: {
					'froalaEditor.initialized': function(e, editor) {
						// editor.toolbar.hide();
                        $('#'+self.randomId + ' .fr-toolbar').addClass('toolbar-hidden');
					},

					'froalaEditor.focus': function(e, editor) {
						// editor.toolbar.show();
                        $('#'+self.randomId + ' .fr-toolbar').removeClass('toolbar-hidden');
					},

					'froalaEditor.blur': function(e, editor) {
						// editor.toolbar.hide();
                        $('#'+self.randomId + ' .fr-toolbar').addClass('toolbar-hidden');
					}
			    }

            },

            isLoaded: false,

        }

    },

    created() {

    	// set licence key for froala
    	this.froalaConfig.key = this.$config.froalaKey;

        this.froalaConfig.imageUploadURL = this.$config.api + 'fileProcessing/upload?preset=equipmentCatalogPageElement&froala=1';
		// this.froalaConfig.imageManagerLoadURL = this.$config.assets + 'equipmentCatalog';

    },

    mounted() {


    },

    updated() {


    },


    methods: {


    }

}
</script>


<style>

    /* toolbar styling */
    .ecpec .fr-toolbar .fr-command.fr-btn {
        width: 28px;
        height: 28px;
    }
    .ecpec .fr-toolbar .fr-command.fr-btn i {
        margin: 6px 8px;
    }
    .ecpec .fr-separator.fr-vs {
        height: 24px;
        width: 1px;
        margin: 2px;
    }
    .ecpec .fr-command i {
		vertical-align: middle !important;
	}


    .ecpec .fr-box {
        position: relative;
        margin-top: -30px;
    }
    .ecpec .fr-wrapper {
        box-shadow: none !important;
    }
    .ecpec .fr-toolbar {
        border-top-width: 2px;
    }
    .ecpec .fr-toolbar.toolbar-hidden {
        visibility: hidden;
    }



    /* editor content elements */
    .ecpec .fr-element {
        font-size: 8pt;
        line-height: 12pt !important;
        padding: 0 !important;
    }
    .ecpec .fr-element a {
        text-decoration: underline !important;
    }
    .ecpec .fr-element table tr td {
        white-space: pre-wrap;
        max-width: 100%
    }
    .ecpec .fr-element .fr-img-caption .fr-img-wrap > span {
        font-size: 8pt;
        line-height: 12pt;
        font-style: italic;
    }

    .fr-command.fr-btn+.fr-dropdown-menu .fr-dropdown-wrapper .fr-dropdown-content ul.fr-dropdown-list li a {
        border: none;
    }
</style>
